import React from 'react'
import { motion } from 'framer-motion'
import { useEase } from '../components/motion'

export class AccentBar extends React.Component {
   constructor(props) {
      super(props);
      this.accentBarRef = React.createRef()
   }

   render() {
      const theme = this.props.theme ? this.props.theme: ''
      const classes = `accentBar-container accentBar-${theme}`

      return (
         <div className={classes}>
            <div className='accentBar' ref={this.accentBarRef}></div>
            {this.props.children}
         </div>
      )
   }
}

export const Logo = (props) => {
	const easing = [0.76, 0, 0.24, 1]
	const runTime = 5
	const delay = 0.25

	const redVar = {
		stop: {
			x: 0,
		},
		start: {
			x: [0, 65, 0],
			transition: {
				ease: easing,
				duration: runTime,
				repeat: Infinity,
				repeatDelay: delay,
			},
		}
	}

	const cyanVar = {
		stop: {
			x: 0
		},

		start: {
			x: [0, -65, 0],
			transition: {
				ease: easing,
				duration: runTime,
				repeat: Infinity,
				repeatDelay: delay,
			},
		},
	}
   return (
		<div className="twentytwenty">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="154.43"
				height="48.62"
				viewBox="0 0 154.43 48.62"
			>
				<motion.g
					id="red"
					variants={redVar}
					inital="stop"
					animate={props.animate ? "start" : "stop"}
				>
					<path
						fill="red"
						d="M36.59,30.52V47H0L13.08,21.14l-12-7.4C4.23,5.28,10.9,0,19.55,0,29.26,0,36,6.41,36,15.13c0,6.4-4.69,12.15-9.78,15.39Z"
					/>
					<path
						fill="red"
						d="M41,23.85C41,10.11,51.12,0,65,0S88.84,10.11,88.84,23.85s-10.11,24-23.78,24C51.12,47.82,41,37.72,41,23.85Z"
					/>
				</motion.g>
				<motion.g
					id="cyan"
					variants={cyanVar}
					inital="stop"
					animate={props.animate ? "start" : "stop"}
				>
					<path
						fill="aqua"
						d="M102.19,31.32V47.83H65.59L78.67,21.94l-12-7.4C69.82,6.08,76.49.8,85.15.8c9.71,0,16.44,6.41,16.44,15.13,0,6.4-4.69,12.15-9.77,15.39Z"
					/>
					<path
						fill="aqua"
						d="M106.61,24.65c0-13.74,10.11-23.85,24-23.85s23.84,10.11,23.84,23.85-10.1,24-23.78,24C116.72,48.62,106.61,38.52,106.61,24.65Z"
					/>
				</motion.g>
			</svg>
		</div>
   )
}